const API_BASE = process.env.REACT_APP_API_URL || '/api';
const PUBLIC_URL = process.env.PUBLIC_URL || '';

export async function apiFetch(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    headers: {
      Accept: 'application/json',
      ...options.headers,
    },
    ...options,
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }

  return response.json();
}

export function mediaUrl(path) {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  // uploads/ y api/ viven en la raíz del dominio, no bajo /site/
  if (path.startsWith('/uploads/') || path.startsWith('/api/')) return path;
  if (path.startsWith('/')) return `${PUBLIC_URL}${path}`;
  return path;
}
